import type { ModuleRoute } from '../util'
import { mixinParams } from '../util'
import { SETTING_MANAGE_TYPE } from '@/views/teacher/setting/constant'

export const settingManagerRouteMap = {
  29001: {
    path: 'paper',
    name: 'PaperSetting',
    component: () => import('@/views/teacher/setting/SettingManagePage.vue'),
    props: {
      type: SETTING_MANAGE_TYPE.enums.PaperSetting.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [29000, 29001],
      moduleChildren: [],
    },
  },
}
mixinParams({ ...settingManagerRouteMap }, { moduleName: 'setting' })

export default {
  path: '/:symbol([A-Za-z]+)/manager/:module(setting)/',
  component: () => import('@/components/teacher/layout/ManagerPageLayout.vue'),
  children: Object.values(settingManagerRouteMap as ModuleRoute),
}

